import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ForPartnersNameInput = ({ register, errors, defaultValue, disabled } : { register: any, errors: any, defaultValue?: any, disabled?: boolean }) => {
    const [isFocused, setIsFocused] = useState<boolean>(false)
    const { t } = useTranslation()

    const handleBlur = () => {
        setIsFocused(false)
    }

    return (
        <div className={`for-partners__input-block ${isFocused && 'for-partners__input-block_focused'}`}>
            <label style={errors.name ? { color: '#D17CF9' } : {}} htmlFor='name'>{errors.name ? errors.name.message ? errors.name.message : t('footerFormerror') : t('footerFormnameUp')}</label>
            {/* {errors.name && <p style={{ color: 'red', fontSize: 12 }}>{ }</p>} */}
            <input
                style={errors.name ? { color: '#D17CF9' } : {}}
                autoComplete='off'
                onBlurCapture={handleBlur}
                onFocus={() => setIsFocused(true)}
                name='name'
                type='text'
                defaultValue={defaultValue ? defaultValue : ""}
                placeholder={t('footerFormnamePlaceholder')}
                disabled={disabled}
                {...register('name', {
                    disabled: disabled,
                    defaultValue: defaultValue ? defaultValue : "",
                    // validate: (value) => {
                    //     const words = value.trim().split(/\s+/);
                    //     return (
                    //         words.length === 2 &&
                    //         words.every((word) => word.length >= 2)
                    //     );
                    // },
                    minLength: {
                        value: 2,
                        message: t('footerFormnameErrorLength')
                    },
                    pattern: {
                        value: /^[\u0400-\u04FF\s]+$/,
                        message: t('footerFormnameErrorCyrillic'),
                    },
                    required: t('footerFormrequired')
                })}
            />
        </div>
    )
}

export default ForPartnersNameInput
